import { Gender, LinkType, ResourceDefinition } from '@case-app/angular-library'

export const monitoringLatenessDefinition: ResourceDefinition = {
  title: 'Retards - Monitoring',
  nameSingular: 'NOT APPLICABLE',
  namePlural: 'retards',
  gender: Gender.Feminine,
  mainIdentifier: 'NOT APPLICABLE',
  slug: 'monitoring/lateness',
  path: 'monitoring/lateness',
  className: 'NOT APPLICABLE',
  icon: 'NOT APPLICABLE',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [],
  keyNumbers: []
}
